import createTheme from "@mui/material/styles/createTheme";
import { Theme } from "@mui/material/styles";

declare module "@mui/material/styles" {
	interface Theme {
		status: {
			danger: React.CSSProperties["color"];
		};
	}
	interface TypographyVariants {
		poster: React.CSSProperties;
	}

	interface TypographyVariantsOptions {
		poster?: React.CSSProperties;
	}
	interface Palette {
		yellow: Palette["primary"];
		blueGrey: Palette["primary"];
		teal: Palette["primary"];
		brown: Palette["primary"];
	}
	interface PaletteOptions {
		yellow: PaletteOptions["primary"];
		blueGrey: PaletteOptions["primary"];
		teal: PaletteOptions["primary"];
		brown: PaletteOptions["primary"];
	}

	interface ThemeOptions {
		status: {
			danger: React.CSSProperties["color"];
		};
	}
}

const spacingStyles = (theme: Theme, spacingTypesLength = 0, spacingKeyLabel = "spacing-xs") => {
	const hashMap = {} as any;
	new Array(spacingTypesLength)
		.fill(0)
		.map((_, index) => {
			return {
				spacing: index + 1,
				themeSpacingValue: theme.spacing(index + 1),
			};
		})
		.map(({ spacing, themeSpacingValue }) => {
			themeSpacingValue = themeSpacingValue.replace(/[^0-9]/g, "");
			hashMap[`${spacingKeyLabel}-${spacing}`] = {
				margin: `-${themeSpacingValue}px`,
				width: `calc(100% + ${(themeSpacingValue as any) * 2}px)`,
				"> .MuiGrid-item": {
					padding: themeSpacingValue + "px",
				},
			};
			return true;
		});
	return hashMap;
};

export const getTheme = (): Theme => {
	let theme = createTheme({
		typography: {
			// fontFamily: ["Open sans"].join(","),
			allVariants: {
				color: "#2a292a",
			},
		},
		status: {
			danger: "#e53e3e",
		},
		palette: {
			primary: {
				main: "#3b79c0", // main blue
			},
			secondary: {
				main: "#9575cd", // violet
				light: "#9990A1", // dull violet
			},
			error: {
				main: "#E7554A", // red
				light: "#ec7474", // light red
			},
			success: {
				main: "#6FB934", // light green
			},
			yellow: {
				main: "#F4D03F",
			},
			blueGrey: {
				dark: "#73757A",
				main: "#d7dee5",
				light: "#f5f7fb",
			},
			grey: {
				900: "#2a292a", // dark grey
			},
			teal: {
				main: "#40E0D0",
			},
			brown: {
				main: "#A0522D",
			},
		},
	});

	theme = createTheme(theme, {
		components: {
			MuiGrid: {
				styleOverrides: {
					...spacingStyles(theme, 10),
				},
			},
			MuiAccordionDetails: {
				styleOverrides: {
					root: {
						padding: 0,
					},
				},
			},
			MuiInputLabel: {
				styleOverrides: {
					root: {
						fontSize: "14px",
					},
					outlined: {
						zIndex: 1,
						transform: "translate(14px, 20px) scale(1)",
						pointerEvents: "none",
						top: "-9px",
						color: "#9990a1",
						fontSize: "14px",
					},
					shrink: {
						transform: "translate(14px, 2px) scale(0.75) !important",
					},
				},
			},
		},
	});
	return theme;
};

export type ThemeInterface = Theme;
